/**
 * Maps a backend order schedule onto subscription-aware order objects.
 *
 * One-time line items (Loop's `isOneTimeAdded`) ship once, on the next
 * unprocessed order. `includeOneTimesOnFirst` decides whether this view keeps
 * them (on the first unprocessed order) or strips them entirely.
 */

type MapOrderScheduleOptions = {
  includeOneTimesOnFirst?: boolean;
};

export const mapOrderSchedule = (
  orderSchedule: any,
  subscription: any,
  options: MapOrderScheduleOptions = {},
) => {
  const { includeOneTimesOnFirst = false } = options;
  const subscriptionLines: ILineItem[] = subscription?.lines ?? [];
  const recurringLines = subscriptionLines.filter((line) => !line?.isOneTimeAdded);

  // Anchor one-times to the first order that's neither SKIPPED nor PROCESSED:
  // an in-fulfilment order can't carry them, Loop attaches them to the next one.
  const firstUnprocessedId = includeOneTimesOnFirst
    ? orderSchedule.find(
        (order: any) => order?.status !== 'SKIPPED' && order?.status !== 'PROCESSED',
      )?.id
    : undefined;

  return orderSchedule.map((order: any) => {
    const keepOneTimes = includeOneTimesOnFirst && order?.id === firstUnprocessedId;
    return {
      ...order,
      currencyCode: subscription?.currencyCode,
      lines: keepOneTimes ? subscriptionLines : recurringLines,
      shippingAddress: subscription?.shippingAddress,
      totalLineItems: subscription?.totalLineItems,
      paymentMethodId: subscription?.paymentMethodId,
    };
  });
};
